module.exports = __webpack_public_path__ + "static/media/AR-products-one@2x.51b08068.png";